/** 
 * ! Do not edit or delete this file !
 * This file dynamically imports your asset files for Parcel JS.
 * We don't bundle the /vendor folder.
 * Add your own css & js in the child folders: /css & /js
 */
import * as css from './css/*.css';
import * as js from './js/*.js';
export { css, js }